import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

// ── สร้างการแจ้งเตือนให้ผู้ใช้ ─────────────────────────────────────────────
export async function createNotif(uid, { type, title, message, roomId = null }) {
  if (!uid) return;
  try {
    await addDoc(collection(db, "users", uid, "notifications"), {
      type,       // "deal" | "withdraw" | "dispute" | "system"
      title,
      message,
      roomId,
      read: false,
      createdAt: serverTimestamp(),
    });
  } catch (_) {}
}

// ── Shortcut helpers ────────────────────────────────────────────────────────
export const notif = {
  dealDeposited:  (uid, item, roomId) => createNotif(uid, { type:"deal",     title:"มีผู้วางมัดจำแล้ว",           message:`ผู้ซื้อวางเงินสำหรับ "${item}" แล้ว กรุณาเตรียมจัดส่ง`, roomId }),
  dealShipped:    (uid, item, roomId) => createNotif(uid, { type:"deal",     title:"ผู้ขายส่งของแล้ว",             message:`"${item}" ถูกส่งแล้ว กรุณาตรวจสอบและยืนยันรับของ`, roomId }),
  dealCompleted:  (uid, item, roomId) => createNotif(uid, { type:"deal",     title:"ดีลสำเร็จ!",                   message:`ได้รับเงินจากดีล "${item}" แล้ว`, roomId }),
  dealDisputed:   (uid, item, roomId) => createNotif(uid, { type:"dispute",  title:"มีการเปิดข้อพิพาท",            message:`ดีล "${item}" ถูกเปิดข้อพิพาท Admin จะดำเนินการตรวจสอบ`, roomId }),
  dealRefunded:   (uid, item, roomId) => createNotif(uid, { type:"deal",     title:"คืนเงินแล้ว",                  message:`เงินจากดีล "${item}" ถูกคืนให้คุณแล้ว`, roomId }),
  withdrawOk:     (uid, amount)       => createNotif(uid, { type:"withdraw", title:"อนุมัติถอนเงิน",               message:`ถอนเงิน ฿${amount.toLocaleString()} ได้รับการอนุมัติแล้ว` }),
  withdrawReject: (uid, amount, note) => createNotif(uid, { type:"withdraw", title:"ปฏิเสธถอนเงิน",               message:`คำขอถอน ฿${amount.toLocaleString()} ถูกปฏิเสธ${note ? `: ${note}` : ""}` }),
  topupOk:        (uid, amount)       => createNotif(uid, { type:"system",   title:"เติมเงินสำเร็จ",               message:`เติมเงิน ฿${amount.toLocaleString()} เข้า Wallet แล้ว` }),
  topupReject:    (uid, note)         => createNotif(uid, { type:"system",   title:"ปฏิเสธแจ้งโอนเงิน",           message:`คำขอเติมเงินถูกปฏิเสธ${note ? `: ${note}` : ""}` }),
  newMessage:     (uid, senderName, text, roomId) => createNotif(uid, { type:"message", title:`ข้อความใหม่จาก ${senderName}`, message: text.length > 80 ? text.slice(0, 80) + "…" : text, roomId }),
};
